import Tour from 'reactour';
import './TourProvider.css';

export interface TourProviderProps {
  steps: Array<any>;
  isOpen: boolean;
  onRequestClose: () => void;
  showNumber?: boolean;
  showNavigation?: boolean;
  showNavigationNumber?: boolean;
  disableInteraction?: boolean;
  lastStepNextButton?: React.ReactNode;
  accentColor?: string;
  rounded?: number;
}

/**
 * Centralized TourProvider wrapper with consistent configuration
 * Ensures proper z-index hierarchy: modal (5001) > tour (1500) > content (auto)
 * Z-index is set via CSS in global styles to ensure proper layering
 */
function TourProvider({
  steps,
  isOpen,
  onRequestClose,
  showNumber = false,
  showNavigation = false,
  showNavigationNumber = false,
  disableInteraction = true,
  lastStepNextButton,
  accentColor = '#ffbf00',
  rounded = 16,
}: TourProviderProps): JSX.Element {
  return (
    <Tour
      steps={steps}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      showNumber={showNumber}
      showNavigation={showNavigation}
      showNavigationNumber={showNavigationNumber}
      disableInteraction={disableInteraction}
      lastStepNextButton={lastStepNextButton}
      accentColor={accentColor}
      rounded={rounded}
    />
  );
}

export default TourProvider;
